module.exports = __webpack_public_path__ + "img/logo.6a78c9a0.svg";